import React, { useEffect, useState } from "react";
import SettingsEmptyState from './SettingsEmptyState';
import {
  ConfirmDelete,
  MwInputText,
  MwSpinner,
  MwSpinnerButton,
} from "../ui";
import { IoMdAdd } from "react-icons/io";

import MwSelectorAccount from "../ui/MwSelectorAccount";
import { useTranslation } from "react-i18next";
import { AiOutlineDelete } from "react-icons/ai";
import { useCurrent, useDelete, useFetch, usePost, usePut } from "../../hooks";
import { NewButton } from "../ui/NewButton";
import { BiSolidMessageSquareEdit } from "react-icons/bi";
import { NewInputLang } from "../ui/NewInputLang";

export const TypeOfIncomes = () => {
  const { t } = useTranslation("settings");
  const [langar, setLangar] = useState(true);
  const [incomesList, setincomeList] = useState([]);
  const [incomeCode, setincomeCode] = useState("");
  const [incomeName, setincomeName] = useState("");
  const [incomeEnName, setincomeEnName] = useState("");
  const [error, setError] = useState({});
  const [onShow, setOnShow] = useState(false);
  const [selectedincomeId, setSelectedincomeId] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [editingincomeId, setEditingincomeId] = useState(null);
  const { currentTenantId, currentCompanyId, currentBranchId , currentLangId } = useCurrent();
  const { data, postData, loading } = usePost();
  const { loading: delloading, deleteItem } = useDelete();
  const {
    data: incomesResult,
    loading: loadingincomes,
    refreshHandler: refetchincomes,
  } = useFetch(
    `${process.env.REACT_APP_FINANCE_API_SERVER_BASE_URL}/incomes-types/${currentTenantId}/${currentCompanyId}/${currentBranchId}`
  );
  const {
    data: incomesCountResult,
    loading: loadingCountResult,
    refreshHandler,
  } = useFetch(
    `${process.env.REACT_APP_FINANCE_API_SERVER_BASE_URL}/incomes-types/count/${currentTenantId}/${currentCompanyId}/${currentBranchId}`
  );
  const {
    data: savedata,
    loading: saveloading,
    error: saveerr,
    putData,
  } = usePut();

  useEffect(() => {
    if (incomesCountResult && !isEditing) {
      setincomeCode((parseInt(incomesCountResult?.data) + 1).toString());
    }
  }, [incomesCountResult, isEditing]);

  useEffect(() => {
    if (incomesResult?.data) {
      setincomeList(incomesResult.data);
    }
  }, [incomesResult]);

  const addincome = () => {
    let errors = {};

    if (!incomeCode) errors.code = "Code Is Required";
    if (langar && !incomeName) {
      errors.name_ar = "Arabic And English Name Is Required";
    }
    if (!langar && !incomeEnName) {
      errors.name_en = "English And Arabic Name Is Required";
    }

    if (Object.keys(errors).length > 0) {
      setError(errors);
      return;
    }

    const incomeData = {
      code: incomeCode,
      name_ar: incomeName || "-",
      name_en: incomeEnName || "-",
      tenant_id: currentTenantId,
      company_id: currentCompanyId,
      branch_id: currentBranchId,
    };

    const resetForm = () => {
      setincomeCode("");
      setincomeName("");
      setincomeEnName("");
      setIsEditing(false);
      setEditingincomeId(null);
      setError({});
    };

    if (!isEditing) {
      postData(
        `${process.env.REACT_APP_FINANCE_API_SERVER_BASE_URL}/incomes-types`,
        incomeData
      ).then(() => {
        refetchincomes();
        refreshHandler();
        resetForm();
      });
    } else {
      putData(
        `${process.env.REACT_APP_FINANCE_API_SERVER_BASE_URL}/incomes-types/${editingincomeId}`,
        incomeData,
        "settings"
      ).then(() => {
        refetchincomes();
        refreshHandler();
        resetForm();
      });
    }
  };

  const deleteincome = (id) => {
    deleteItem(
      `${process.env.REACT_APP_FINANCE_API_SERVER_BASE_URL}/incomes-types/${id}`
    ).then(() => {
      refetchincomes();
      refreshHandler();
      setOnShow(false);
    });
  };

  return (
    <>
      {!incomeCode ? (
        <div className="h-20 w-full justify-center items-center flex">
          <MwSpinnerButton />
        </div>
      ) : (
        <section className="flex flex-col flex-1">
          <ConfirmDelete
            onShow={onShow}
            setOnShow={setOnShow}
            onDeleteHandler={() => deleteincome(selectedincomeId)}
            loading={delloading}
            msg={t("income.incomedel")}
          />
          <div className="flex justify-start w-full items-end gap-2">
            <div className="w-28">
              <MwInputText
                invalid={error?.code}
                disabled={true}
                label={t("income.incomecode")}
                value={incomeCode}
                onChange={(e) => setincomeCode(e.target.value)}
                classNameInput="w-[100%] text-center  flex-1  "
              />
            </div>
            <div className="w-80 flex flex-col justify-center">
              <NewInputLang
                invalid={error?.name_ar || error?.name_en}
                placeholder={t("income.incomenameplaceholder")}
                label={t("income.incomename")}
                value={langar ? incomeName : incomeEnName}
                langar={langar}
                onChange={(value) => {
                  if (langar) {
                    setincomeName(value);
                  } else {
                    setincomeEnName(value);
                  }
                }}
                onChangeLang={() => setLangar(!langar)}
                classNameInput="w-[100%] flex-1"
              />
            </div>

            <div className="group">
              <NewButton onClick={addincome}>
                {loading || saveloading ? (
                  <MwSpinnerButton />
                ) : isEditing ? (
                  t("general.update")
                ) : (
                  <>
                    <IoMdAdd className="text-white text-lg group-hover:text-[#ffffff]" />
                    <p className="">{t("general.Add")}</p>
                  </>
                )}
              </NewButton>
            </div>
          </div>

          {loadingincomes && incomesList?.length === 0 ? (
            <div className="h-40 flex justify-center items-center w-full">
              {" "}
              <MwSpinnerButton />
            </div>
          ) : incomesList?.length > 0 ? (
            <>
              <>
                <div className="flex w-full mt-3 justify-around bg-[#F2F0FC] p-3 rounded-t-lg font-[800] text-[#251658] text-sm">
                  <div className="w-0 text-center">#</div>
                  <div className="w-52 text-center">
                    {t("income.incomecode")}
                  </div>
                  <div className="flex-1 text-center">
                    {t("income.incomename")}
                  </div>
              
                  <div className="flex-1 text-center"></div>
                </div>
                <div className="divide-y  ">
                  {incomesList.map((item, index) => (
                    <div
                      key={index}
                      className="flex w-full border-b border-[#ddd0bf] border-opacity-25 cursor-pointer justify-around items-center p-3 text-[#251658] font-semibold text-sm"
                    >
                      <div className="w-1 text-center">{index + 1}</div>
                      <div className="w-52 text-center">{item?.code}</div>
                      <div className=" flex-1 text-center">
                         { currentLangId==="ar" ?  item?.name_ar : item?.name_en}
                      </div>
                  
                      <div className=" flex me-4 justify-end items-center flex-1 text-end gap-1">
                        <button
                          onClick={() => {
                            setIsEditing(true);
                            setEditingincomeId(item.id);
                            setincomeCode(item.code);
                            setincomeEnName(item.name_en);
                            
                            setincomeName(
                              item.name_ar || item.name_en || item.name
                            );
                          }}
                          className="text-blue-500 hover:text-blue-700 mx-2"
                        >
                          <img
                            className="w-4"
                            src="/assets/icons/Edit.png"
                            alt="delete"
                            srcSet=""
                          />
                        </button>
                        <button
                          onClick={() => {
                            setSelectedincomeId(item.id);
                            setOnShow(true);
                          }}
                          className="text-red-500 hover:text-red-700"
                        >
                          <img
                            className="w-4"
                            src="/assets/icons/Trash.png"
                            alt="delete"
                            srcSet=""
                          />
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              </>
            </>
          ) : (
              <div className=" h-[calc(100vh-230px)] ">
                        <SettingsEmptyState msg={t('income.validate')} />
                        </div> 
          )}
        </section>
      )}
    </>
  );
};
